// import store from '@/store'
import request from '@/utils/request'

export const getPermissions = async () => {
  return request({
    url: '/permissions',
    method: 'get'
  })
}
